import React from 'react';
import './titlediv.css'; // Import the CSS for styling

const TitleDiv = ({ text }) => {
  return (
    <div className="title-div">
      {text}
    </div>
  );
};

export default TitleDiv;
